<template>
    <div id="whatsapp" class="whatsapp-contact">
        <a class="whatsapp-contact-cta" href="https://api.whatsapp.com/send?phone=573103708276" target="_blank">
            <span class="icon-whatsapp"></span>
        </a>
        <div class="whatsapp-contact-info">
            <span class="whatsapp-contact-info-title">¿Necesitas soporte?</span>
            <span class="whatsapp-contact-info-description">Escríbenos para ayudarte</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'whatsapp-contact',
}
</script>
<style lang="scss" scoped>
    #whatsapp {
        bottom: 38px;
        font-family: Poppins;
        position: fixed;
        right: 38px;
        z-index: 100;
    }
    .whatsapp-contact {
        &-cta {
            align-items: center;
            background: #73C914;
            border-radius: 50%;
            color: white;
            display: flex;
            height: 58px;
            justify-content: center;
            width: 58px;
            &:hover {
                color: white;
                text-decoration: none;
            }
            &:hover + .whatsapp-contact-info {
                opacity: 1;
                visibility: visible;
            }
            span.icon-whatsapp {
                font-size: 19px;
            }
        }
        &-info {
            background: white;
            border-radius: 40px;
            box-shadow: 0 0 10px 0px rgb(0 0 0 / 15%);
            -webkit-box-shadow: 0 0 10px 0px rgb(0 0 0 / 15%);
            -moz-box-shadow: 0 0 10px 0px rgb(0 0 0 / 15%);
            color: #686868;
            display: flex;
            font-size: 12px;
            flex-direction: column;
            height: 70px;
            justify-content: center;
            top: -6px;
            right: -8px;
            min-width: 260px;
            padding: 10px 0 10px 20px;
            position: absolute;
            z-index: -1;
            visibility: hidden;
            opacity: 0;
            transition: opacity 300ms, visibility 300ms ease-in;
            &-title, &-description {
                display: block;
            }
            &-title {
                font-weight: bold;
            }
        }
    }
</style>
